import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-foreground-500">
            Everything you need to know about Kakobuy Spreadsheet — answered.
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-base text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 md:px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}